import { useEffect } from 'react';
import { Input, Select, Switch, Form } from 'antd';
import { Box, Typography, Stack } from '@mui/material';
import ActionButton from 'components/button/ActionButton';
import SmoothDrawerContainer from './SmoothDrawerContainer';

const { Option } = Select;

const EdgeConfigurationDrawer = ({ setEdges, setNodes, disabled = false, edge, onClose }) => {
	const [form] = Form.useForm();

	const handleDelete = () => {
		setEdges((eds) => eds.filter((e) => e.id !== edge.id));

		setNodes((nodes) => nodes.map((node) => (node.id === edge?.source ? { ...node, data: { ...node.data, hasChild: false } } : node)));

		onClose();
	};

	const handleSubmitConfiguration = (values) => {
		setEdges((eds) =>
			eds.map((ed) =>
				ed.id === edge.id
					? {
							...ed,
							type: values?.type,
							label: values?.label,
							animated: values?.animated,
						}
					: ed
			)
		);

		onClose();
	};

	useEffect(() => {
		if (edge) {
			const edgeData = edge;

			form?.setFieldsValue({
				type: edgeData?.type ? edgeData?.type : '',
				label: edgeData?.label,
				animated: edgeData?.animated,
			});
		}
	}, [edge]);

	return (
		<SmoothDrawerContainer open={true} onClose={onClose}>
			<Form form={form} disabled={disabled} layout="vertical" onFinish={handleSubmitConfiguration}>
				<Box mb={2}>
					<Typography fontSize={14} fontWeight={500} mb={0.5}>
						Label
					</Typography>

					<Form.Item style={{ marginBottom: 0 }} name="label">
						<Input placeholder="Enter node label" />
					</Form.Item>
				</Box>

				<Box mb={2}>
					<Typography fontSize={14} fontWeight={500} mb={0.5}>
						Line Type
					</Typography>

					<Form.Item style={{ marginBottom: 0 }} name="type">
						<Select style={{ width: '100%' }} getPopupContainer={(trigger) => trigger.parentNode}>
							<Option value="step">Step</Option>
							<Option value="bezier">Bezier</Option>
							<Option value="straight">Straight</Option>
							<Option value="smoothstep">Smooth step</Option>
						</Select>
					</Form.Item>
				</Box>

				<Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
					<Typography fontSize={14} fontWeight={500}>
						Animated
					</Typography>

					<Form.Item style={{ marginBottom: 0 }} name="animated">
						<Switch />
					</Form.Item>
				</Box>

				{!disabled && (
					<Stack direction="row" justifyContent="flex-end" sx={{ mt: 3, gap: '12px' }}>
						<ActionButton onClick={handleDelete} tooltip="Delete" variantType="reject" label="Delete" />
						<ActionButton type="submit" tooltip="Save" variantType="save" label="Save" />
					</Stack>
				)}
			</Form>
		</SmoothDrawerContainer>
	);
};

export default EdgeConfigurationDrawer;
